module.exports = __webpack_public_path__ + "static/media/metamask.15e22fef.png";